import { useState, useEffect } from 'react'

interface ScreenDimensions {
    width: number
    height: number
    zoom: number
}

/**
 * Custom hook to observe screen height, width, and zoom changes
 * @returns {ScreenDimensions} Current screen dimensions and zoom level
 */
export const useScreenObserver = (): ScreenDimensions => {
    const getScreenData = (): ScreenDimensions => ({
        width: window.innerWidth,
        height: window.innerHeight,
        zoom: Math.round((window.outerWidth / window.innerWidth) * 100) / 100
    })

    const [screenData, setScreenData] = useState<ScreenDimensions>(getScreenData)

    useEffect(() => {
        const handleResize = () => {
            setScreenData(getScreenData())
        }

        window.addEventListener('resize', handleResize)
        window.addEventListener('orientationchange', handleResize)

        return () => {
            window.removeEventListener('resize', handleResize)
            window.removeEventListener('orientationchange', handleResize)
        }
    }, [])

    return screenData
}